<mat-sidenav-container class="h-100 min-h-0 content" [hasBackdrop]="false">
  <mat-sidenav-content (click)="onCloseDetails()">
    <div class="reports-page flex-col gap-16 h-100 min-h-0">
      <div class="page-title flex-col gap-8">
        <span class="incident-count">
          {{
            'REPORTS.INCIDENTS_COUNT'
              | translate: { count: sortedRows().length }
          }}
        </span>
      </div>

      <div class="filters-row gap-8">
        <div class="filter-search">
          <ui-search
            [placeholder]="'REPORTS.FILTERS.SEARCH' | translate"
            [heightPx]="32"
            [ngModel]="searchQuery()"
            (ngModelChange)="onSearchQueryChange($event)"
          ></ui-search>
        </div>

        <div class="filter-select">
          <ui-calendar
            [inputStyle]="inputStyles.noLabel"
            [inputConfig]="calendarInputConfig"
            [showAdvancedOption]="true"
            [selectDateRange]="selectedDateRange()"
            (rangeSelected)="onDateRangeChange($event)"
          ></ui-calendar>
        </div>

        <div class="filter-select">
          <mat-select
            class="ui-selector"
            panelClass="reports-filter-panel"
            [placeholder]="'REPORTS.FILTERS.ALL_STATUSES' | translate"
            [ngModel]="selectedStatus()"
            (ngModelChange)="onStatusFilterChange($event)"
          >
            <mat-select-trigger>
              <span class="filter-select-text" uiTruncateText>
                @if (selectedStatus() === null) {
                  {{ 'REPORTS.FILTERS.ALL_STATUSES' | translate }}
                } @else {
                  {{ getStatusFilterLabelKey(selectedStatus()!) | translate }}
                }
              </span>
            </mat-select-trigger>
            <mat-option [value]="null">
              <span class="filter-option-text" uiTruncateText>
                {{ 'REPORTS.FILTERS.ALL_STATUSES' | translate }}
              </span>
            </mat-option>
            @for (status of statusFilterOptions; track status) {
              <mat-option [value]="status">
                <span class="filter-option-text" uiTruncateText>
                  {{ getStatusFilterLabelKey(status) | translate }}
                </span>
              </mat-option>
            }
          </mat-select>
        </div>

        <div class="filter-select">
          <mat-select
            class="ui-selector"
            panelClass="reports-filter-panel"
            [placeholder]="'REPORTS.FILTERS.ALL_OPERATORS' | translate"
            [ngModel]="selectedOperator()"
            (ngModelChange)="onOperatorFilterChange($event)"
          >
            <mat-select-trigger>
              <span class="filter-select-text" uiTruncateText>
                @if (selectedOperator() === null) {
                  {{ 'REPORTS.FILTERS.ALL_OPERATORS' | translate }}
                } @else if (selectedOperator() === unassignedOperatorFilter) {
                  {{ 'HOME.UNASSIGNED' | translate }}
                } @else {
                  {{ selectedOperator() }}
                }
              </span>
            </mat-select-trigger>
            <mat-option [value]="null">
              <span class="filter-option-text" uiTruncateText>
                {{ 'REPORTS.FILTERS.ALL_OPERATORS' | translate }}
              </span>
            </mat-option>
            <mat-option [value]="unassignedOperatorFilter">
              <span class="filter-option-text" uiTruncateText>
                {{ 'HOME.UNASSIGNED' | translate }}
              </span>
            </mat-option>
            @for (operator of operatorOptions(); track operator) {
              <mat-option [value]="operator">
                <span class="filter-option-text" uiTruncateText>{{
                  operator
                }}</span>
              </mat-option>
            }
          </mat-select>
        </div>

        <div class="filter-select">
          <mat-select
            class="ui-selector"
            panelClass="reports-filter-panel"
            [placeholder]="'REPORTS.FILTERS.ALL_ORGANIZATIONS' | translate"
            [ngModel]="selectedOrganization()"
            (ngModelChange)="onOrganizationFilterChange($event)"
          >
            <mat-select-trigger>
              <span class="filter-select-text" uiTruncateText>
                @if (selectedOrganization() === null) {
                  {{ 'REPORTS.FILTERS.ALL_ORGANIZATIONS' | translate }}
                } @else {
                  {{ selectedOrganization() }}
                }
              </span>
            </mat-select-trigger>
            <mat-option [value]="null">
              <span class="filter-option-text" uiTruncateText>
                {{ 'REPORTS.FILTERS.ALL_ORGANIZATIONS' | translate }}
              </span>
            </mat-option>
            @for (organization of organizationOptions(); track organization) {
              <mat-option [value]="organization">
                <span class="filter-option-text" uiTruncateText>{{
                  organization
                }}</span>
              </mat-option>
            }
          </mat-select>
        </div>

        <div class="filter-select">
          <mat-select
            class="ui-selector"
            panelClass="reports-filter-panel"
            [placeholder]="'REPORTS.FILTERS.ALL_ACCOUNTS' | translate"
            [ngModel]="selectedAccount()"
            (ngModelChange)="onAccountFilterChange($event)"
          >
            <mat-select-trigger>
              <span class="filter-select-text" uiTruncateText>
                @if (selectedAccount() === null) {
                  {{ 'REPORTS.FILTERS.ALL_ACCOUNTS' | translate }}
                } @else {
                  {{ selectedAccount() }}
                }
              </span>
            </mat-select-trigger>
            <mat-option [value]="null">
              <span class="filter-option-text" uiTruncateText>
                {{ 'REPORTS.FILTERS.ALL_ACCOUNTS' | translate }}
              </span>
            </mat-option>
            @for (account of accountOptions(); track account) {
              <mat-option [value]="account">
                <span class="filter-option-text" uiTruncateText>{{
                  account
                }}</span>
              </mat-option>
            }
          </mat-select>
        </div>

        <div class="filter-select">
          <mat-select
            class="ui-selector"
            panelClass="reports-filter-panel"
            [placeholder]="'REPORTS.FILTERS.ALL_PRIORITIES' | translate"
            [ngModel]="selectedPriority()"
            (ngModelChange)="onPriorityFilterChange($event)"
          >
            <mat-select-trigger>
              <span class="filter-select-text" uiTruncateText>
                @if (selectedPriority() === null) {
                  {{ 'REPORTS.FILTERS.ALL_PRIORITIES' | translate }}
                } @else {
                  {{
                    getPriorityFilterLabelKey(selectedPriority()!) | translate
                  }}
                }
              </span>
            </mat-select-trigger>
            <mat-option [value]="null">
              <span class="filter-option-text" uiTruncateText>
                {{ 'REPORTS.FILTERS.ALL_PRIORITIES' | translate }}
              </span>
            </mat-option>
            @for (priority of priorityOptions; track priority) {
              <mat-option [value]="priority">
                <span class="filter-option-text" uiTruncateText>
                  {{ getPriorityFilterLabelKey(priority) | translate }}
                </span>
              </mat-option>
            }
          </mat-select>
        </div>
      </div>

      <div class="h-100 min-h-0">
        <div class="h-100 min-h-0 flex-col">
          <div
            class="table-wrapper flex-col h-100 min-h-0"
            (click)="$event.stopPropagation()"
          >
            @if (loading()) {
              <div class="w-100 h-100">
                <ui-preloader></ui-preloader>
              </div>
            } @else if (sortedRows().length === 0) {
              <ui-no-data
                [imgSrc]="noResults.imgSrc"
                [title]="noResults.title | translate"
              >
              </ui-no-data>
            } @else {
              <ui-dataset-table
                class="reports-table min-h-0"
                [data]="sortedRows()"
                [config]="tableConfig()"
                [sortState]="sortState()"
                (sortChange)="onSortChange($event)"
                (loadMore)="onLoadMore()"
              ></ui-dataset-table>
            }
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
  <mat-sidenav
    class="incident-details-sidenav"
    mode="over"
    position="end"
    [opened]="incidentDetailsOpen()"
    (click)="$event.stopPropagation()"
  >
    <app-incident-details
      class="incident-details"
      [incident]="selectedIncident()"
      [loading]="incidentDetailsLoading()"
      (closeDetails)="onCloseDetails()"
      (incidentStatusChanged)="onIncidentStatusChanged()"
      (maximizeToggle)="onMaximizeIncident()"
    ></app-incident-details>
  </mat-sidenav>
</mat-sidenav-container>

<ng-template #incidentCell let-row>
  <div class="incident-cell">
    <div class="incident-title">{{ row.incidentTitle }}</div>
    <div class="incident-subtitle">{{ row.incidentSubtitle }}</div>
  </div>
</ng-template>

<ng-template #dateCell let-row>
  <div class="date-cell">
    <div class="date-main">{{ row.dateText }}</div>
    <div class="date-sub">{{ row.timeText }}</div>
  </div>
</ng-template>

<ng-template #priorityCell let-row>
  <span [class]="getPriorityClass(row)">
    {{ getPriorityLabelKey(row) | translate }}
  </span>
</ng-template>

<ng-template #statusCell let-row>
  <span [class]="getStatusClass(row)">
    {{ getStatusLabelKey(row) | translate }}
  </span>
</ng-template>

<ng-template #operatorCell let-row>
  @if (row.operatorName) {
    <div class="operator-cell gap-8">
      <span class="operator-dot"></span>
      <span>{{ row.operatorName }}</span>
    </div>
  } @else {
    <span class="operator-unassigned">{{ 'HOME.UNASSIGNED' | translate }}</span>
  }
</ng-template>

<ng-template #organizationCell let-row>
  <span class="organization-cell">{{ row.organizationName }}</span>
</ng-template>

<ng-template #accountCell let-row>
  <span class="account-cell">{{ row.accountName }}</span>
</ng-template>
